import { LocalTime } from "@js-joda/core";
export function createTimelineEvent() {
    return {
        time: LocalTime.now()
    };
}
export function initTimelineEvent(target, source) {
    Object.assign(target, source);
    target.time = LocalTime.parse(source.time.toString());
    return target;
}
